'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.factory("applicationSettings", function ($http, $q) {
  var deferred = $q.defer();
  var settings = null;
  return {
    loaded: deferred.promise,
    get: function get() {
      return this.loaded.then(function () {
        return settings;
      });
    },
    $load: function $load() {
      $http.get("/rest/application/settings").then(function (response) {
        settings = response.data;
        deferred.resolve(settings);
      });
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/services/applicationSettings.js
// module id = 2865
// module chunks = 13